import './PageContainer.css';

const PageEndBlank = () => {
	return (
		<div id="page-end-blank"></div>
	);
};

export default PageEndBlank;
